// Données géographiques pour l'autocomplete pays/ville.
// Régions ordonnées par priorité d'affichage (Afrique en premier).

export const REGIONS = [
  {
    id: 'afrique_ouest',
    label: "Afrique de l'Ouest",
    countries: [
      { code: 'SN', name: 'Sénégal',       cities: ['Dakar', 'Thiès', 'Kaolack', 'Saint-Louis', 'Ziguinchor', 'Touba', 'Mbour'] },
      { code: 'CI', name: "Côte d'Ivoire", cities: ['Abidjan', 'Bouaké', 'Yamoussoukro', 'Daloa', 'San-Pédro', 'Korhogo'] },
      { code: 'ML', name: 'Mali',           cities: ['Bamako', 'Sikasso', 'Mopti', 'Ségou', 'Kayes', 'Gao'] },
      { code: 'GN', name: 'Guinée',         cities: ['Conakry', 'Nzérékoré', 'Kankan', 'Kindia', 'Labé', 'Mamou'] },
      { code: 'TG', name: 'Togo',           cities: ['Lomé', 'Sokodé', 'Kpalimé', 'Atakpamé', 'Kara'] },
      { code: 'BJ', name: 'Bénin',          cities: ['Cotonou', 'Porto-Novo', 'Parakou', 'Abomey-Calavi', 'Bohicon'] },
      { code: 'GH', name: 'Ghana',          cities: ['Accra', 'Kumasi', 'Tamale', 'Cape Coast', 'Tema', 'Sekondi-Takoradi'] },
      { code: 'BF', name: 'Burkina Faso',   cities: ['Ouagadougou', 'Bobo-Dioulasso', 'Koudougou', 'Banfora'] },
      { code: 'NE', name: 'Niger',          cities: ['Niamey', 'Zinder', 'Maradi', 'Agadez', 'Tahoua'] },
      { code: 'NG', name: 'Nigeria',        cities: ['Lagos', 'Abuja', 'Kano', 'Ibadan', 'Benin City', 'Port Harcourt', 'Enugu', 'Kaduna'] },
      { code: 'GW', name: 'Guinée-Bissau',  cities: ['Bissau', 'Bafatá', 'Gabú', 'Cacheu'] },
      { code: 'MR', name: 'Mauritanie',     cities: ['Nouakchott', 'Nouadhibou', 'Rosso', 'Kaédi'] },
      { code: 'GM', name: 'Gambie',         cities: ['Banjul', 'Serrekunda', 'Brikama'] },
      { code: 'SL', name: 'Sierra Leone',   cities: ['Freetown', 'Bo', 'Kenema', 'Makeni'] },
      { code: 'LR', name: 'Liberia',        cities: ['Monrovia', 'Gbarnga', 'Buchanan', 'Harper'] },
      { code: 'CV', name: 'Cap-Vert',       cities: ['Praia', 'Mindelo', 'Santa Maria'] },
    ],
  },
  {
    id: 'afrique_centrale',
    label: 'Afrique Centrale',
    countries: [
      { code: 'CM', name: 'Cameroun',         cities: ['Douala', 'Yaoundé', 'Bafoussam', 'Garoua', 'Bamenda', 'Maroua'] },
      { code: 'CG', name: 'Congo',            cities: ['Brazzaville', 'Pointe-Noire', 'Dolisie', 'Ouesso'] },
      { code: 'CD', name: 'RD Congo',         cities: ['Kinshasa', 'Lubumbashi', 'Mbuji-Mayi', 'Kisangani', 'Goma', 'Bukavu', 'Kananga'] },
      { code: 'GA', name: 'Gabon',            cities: ['Libreville', 'Port-Gentil', 'Franceville', 'Oyem'] },
      { code: 'TD', name: 'Tchad',            cities: ["N'Djaména", 'Moundou', 'Sarh', 'Abéché'] },
      { code: 'CF', name: 'Centrafrique',     cities: ['Bangui', 'Bimbo', 'Mbaïki'] },
      { code: 'GQ', name: 'Guinée équat.',    cities: ['Malabo', 'Bata', 'Ebebiyín'] },
      { code: 'ST', name: 'São Tomé-et-Pr.', cities: ['São Tomé', 'Santo António'] },
    ],
  },
  {
    id: 'afrique_est',
    label: "Afrique de l'Est",
    countries: [
      { code: 'ET', name: 'Éthiopie',   cities: ['Addis-Abeba', 'Dire Dawa', 'Gondar', 'Mekele', 'Bahir Dar'] },
      { code: 'KE', name: 'Kenya',      cities: ['Nairobi', 'Mombasa', 'Kisumu', 'Nakuru', 'Eldoret', 'Thika'] },
      { code: 'TZ', name: 'Tanzanie',   cities: ['Dar es Salaam', 'Dodoma', 'Arusha', 'Mwanza', 'Zanzibar'] },
      { code: 'UG', name: 'Ouganda',    cities: ['Kampala', 'Gulu', 'Lira', 'Mbarara', 'Jinja'] },
      { code: 'RW', name: 'Rwanda',     cities: ['Kigali', 'Butare', 'Gitarama', 'Ruhengeri'] },
      { code: 'BI', name: 'Burundi',    cities: ['Bujumbura', 'Gitega', 'Ngozi'] },
      { code: 'SD', name: 'Soudan',     cities: ['Khartoum', 'Omdurman', 'Port Soudan', 'Kassala'] },
      { code: 'SS', name: 'Soudan du S.', cities: ['Juba', 'Wau', 'Malakal'] },
      { code: 'DJ', name: 'Djibouti',   cities: ['Djibouti', 'Arta', 'Ali Sabieh'] },
      { code: 'SO', name: 'Somalie',    cities: ['Mogadiscio', 'Hargeisa', 'Bosaso'] },
    ],
  },
  {
    id: 'afrique_nord',
    label: 'Afrique du Nord',
    countries: [
      { code: 'MA', name: 'Maroc',   cities: ['Casablanca', 'Rabat', 'Marrakech', 'Fès', 'Tanger', 'Agadir', 'Oujda', 'Meknès', 'Tétouan'] },
      { code: 'DZ', name: 'Algérie', cities: ['Alger', 'Oran', 'Constantine', 'Annaba', 'Blida', 'Tizi Ouzou', 'Tlemcen', 'Sétif'] },
      { code: 'TN', name: 'Tunisie', cities: ['Tunis', 'Sfax', 'Sousse', 'Kairouan', 'Bizerte', 'Gabès', 'Monastir'] },
      { code: 'EG', name: 'Égypte',  cities: ['Le Caire', 'Alexandrie', 'Gizeh', 'Assouan', 'Louxor', 'Port Saïd', 'Suez'] },
      { code: 'LY', name: 'Libye',   cities: ['Tripoli', 'Benghazi', 'Misrata', 'Syrte'] },
    ],
  },
  {
    id: 'afrique_sud',
    label: 'Afrique Australe',
    countries: [
      { code: 'ZA', name: 'Afrique du Sud', cities: ['Johannesburg', 'Le Cap', 'Pretoria', 'Durban', 'Port Elizabeth', 'Bloemfontein', 'East London'] },
      { code: 'AO', name: 'Angola',          cities: ['Luanda', 'Huambo', 'Lobito', 'Benguela', 'Malanje'] },
      { code: 'MZ', name: 'Mozambique',      cities: ['Maputo', 'Beira', 'Nampula', 'Quelimane', 'Tete'] },
      { code: 'ZM', name: 'Zambie',          cities: ['Lusaka', 'Kitwe', 'Ndola', 'Livingstone'] },
      { code: 'ZW', name: 'Zimbabwe',        cities: ['Harare', 'Bulawayo', 'Mutare', 'Gweru'] },
      { code: 'MW', name: 'Malawi',          cities: ['Lilongwe', 'Blantyre', 'Zomba', 'Mzuzu'] },
      { code: 'MG', name: 'Madagascar',      cities: ['Antananarivo', 'Toamasina', 'Fianarantsoa', 'Mahajanga'] },
      { code: 'MU', name: 'Maurice',         cities: ['Port-Louis', 'Curepipe', 'Quatre Bornes'] },
      { code: 'RE', name: 'La Réunion',      cities: ['Saint-Denis', 'Saint-Paul', 'Le Tampon', 'Saint-Pierre'] },
      { code: 'NA', name: 'Namibie',         cities: ['Windhoek', 'Walvis Bay', 'Swakopmund'] },
      { code: 'BW', name: 'Botswana',        cities: ['Gaborone', 'Francistown', 'Maun'] },
    ],
  },
  {
    id: 'europe_ouest',
    label: "Europe de l'Ouest",
    countries: [
      { code: 'FR', name: 'France',      cities: ['Paris', 'Lyon', 'Marseille', 'Toulouse', 'Nice', 'Bordeaux', 'Lille', 'Nantes', 'Montpellier', 'Strasbourg', 'Rennes', 'Grenoble', 'Tours', 'Rouen', 'Clermont-Ferrand'] },
      { code: 'BE', name: 'Belgique',    cities: ['Bruxelles', 'Anvers', 'Gand', 'Charleroi', 'Liège', 'Bruges', 'Namur'] },
      { code: 'LU', name: 'Luxembourg',  cities: ['Luxembourg', 'Esch-sur-Alzette', 'Differdange'] },
      { code: 'CH', name: 'Suisse',      cities: ['Zurich', 'Genève', 'Bâle', 'Berne', 'Lausanne', 'Lugano'] },
      { code: 'NL', name: 'Pays-Bas',    cities: ['Amsterdam', 'Rotterdam', 'La Haye', 'Utrecht', 'Eindhoven', 'Tilburg'] },
      { code: 'DE', name: 'Allemagne',   cities: ['Berlin', 'Hambourg', 'Munich', 'Cologne', 'Francfort', 'Stuttgart', 'Düsseldorf', 'Leipzig', 'Dortmund', 'Essen'] },
      { code: 'GB', name: 'Royaume-Uni', cities: ['Londres', 'Manchester', 'Birmingham', 'Glasgow', 'Leeds', 'Liverpool', 'Bristol', 'Sheffield', 'Edinburgh', 'Leicester'] },
      { code: 'IE', name: 'Irlande',     cities: ['Dublin', 'Cork', 'Galway', 'Limerick', 'Waterford'] },
      { code: 'ES', name: 'Espagne',     cities: ['Madrid', 'Barcelone', 'Valence', 'Séville', 'Bilbao', 'Malaga', 'Saragosse', 'Alicante'] },
      { code: 'PT', name: 'Portugal',    cities: ['Lisbonne', 'Porto', 'Braga', 'Coimbra', 'Faro', 'Setúbal'] },
      { code: 'IT', name: 'Italie',      cities: ['Rome', 'Milan', 'Naples', 'Turin', 'Palerme', 'Gênes', 'Florence', 'Bologne', 'Venise', 'Bari'] },
      { code: 'AT', name: 'Autriche',    cities: ['Vienne', 'Graz', 'Linz', 'Salzbourg', 'Innsbruck'] },
      { code: 'GF', name: 'Guyane',      cities: ['Cayenne', 'Kourou', 'Saint-Laurent-du-Maroni'] },
      { code: 'MQ', name: 'Martinique',  cities: ['Fort-de-France', 'Le Lamentin', 'Le Robert'] },
      { code: 'GP', name: 'Guadeloupe',  cities: ['Pointe-à-Pitre', 'Basse-Terre', 'Les Abymes'] },
    ],
  },
  {
    id: 'europe_nord_est',
    label: 'Europe du Nord & Est',
    countries: [
      { code: 'SE', name: 'Suède',     cities: ['Stockholm', 'Göteborg', 'Malmö', 'Uppsala', 'Linköping'] },
      { code: 'NO', name: 'Norvège',   cities: ['Oslo', 'Bergen', 'Stavanger', 'Trondheim'] },
      { code: 'DK', name: 'Danemark',  cities: ['Copenhague', 'Aarhus', 'Odense', 'Aalborg'] },
      { code: 'FI', name: 'Finlande',  cities: ['Helsinki', 'Espoo', 'Tampere', 'Turku', 'Oulu'] },
      { code: 'PL', name: 'Pologne',   cities: ['Varsovie', 'Cracovie', 'Łódź', 'Wrocław', 'Poznań', 'Gdańsk'] },
      { code: 'CZ', name: 'Rép. Tchèque', cities: ['Prague', 'Brno', 'Ostrava', 'Pilsen'] },
      { code: 'RO', name: 'Roumanie',  cities: ['Bucarest', 'Cluj-Napoca', 'Timișoara', 'Iași'] },
    ],
  },
  {
    id: 'ameriques',
    label: 'Amériques',
    countries: [
      { code: 'US', name: 'États-Unis', cities: ['New York', 'Los Angeles', 'Chicago', 'Houston', 'Phoenix', 'Atlanta', 'Dallas', 'San Francisco', 'Washington DC', 'Boston', 'Miami', 'Seattle', 'Minneapolis', 'Detroit', 'Denver'] },
      { code: 'CA', name: 'Canada',     cities: ['Toronto', 'Montréal', 'Vancouver', 'Calgary', 'Ottawa', 'Edmonton', 'Winnipeg', 'Québec'] },
      { code: 'BR', name: 'Brésil',     cities: ['São Paulo', 'Rio de Janeiro', 'Brasília', 'Salvador', 'Fortaleza', 'Belo Horizonte', 'Manaus', 'Curitiba'] },
      { code: 'MX', name: 'Mexique',    cities: ['Mexico', 'Guadalajara', 'Monterrey', 'Puebla', 'Cancún', 'Tijuana'] },
      { code: 'CO', name: 'Colombie',   cities: ['Bogotá', 'Medellín', 'Cali', 'Barranquilla', 'Cartagena'] },
      { code: 'HT', name: 'Haïti',      cities: ['Port-au-Prince', 'Cap-Haïtien', 'Gonaïves'] },
    ],
  },
  {
    id: 'moyen_orient_asie',
    label: 'Moyen-Orient & Asie',
    countries: [
      { code: 'AE', name: 'Émirats arabes unis',   cities: ['Dubaï', 'Abu Dhabi', 'Sharjah', 'Ajman'] },
      { code: 'SA', name: 'Arabie saoudite',        cities: ['Riyad', 'Djeddah', 'La Mecque', 'Médine', 'Dammam'] },
      { code: 'QA', name: 'Qatar',                  cities: ['Doha', 'Al Wakrah', 'Al Rayyan'] },
      { code: 'TR', name: 'Turquie',                cities: ['Istanbul', 'Ankara', 'Izmir', 'Bursa', 'Adana', 'Gaziantep'] },
      { code: 'CN', name: 'Chine',                  cities: ['Pékin', 'Shanghai', 'Guangzhou', 'Shenzhen', 'Wuhan', 'Chengdu', 'Yiwu', 'Hangzhou'] },
      { code: 'IN', name: 'Inde',                   cities: ['Mumbai', 'Delhi', 'Bangalore', 'Kolkata', 'Chennai', 'Hyderabad', 'Pune', 'Ahmedabad'] },
    ],
  },
];

/** Liste plate de tous les pays avec métadonnées région */
export const COUNTRIES = REGIONS.flatMap(region =>
  region.countries.map(c => ({ ...c, region: region.id, regionLabel: region.label }))
);

/** Villes d'un pays (par code ISO) */
export function getCitiesForCountry(code) {
  return COUNTRIES.find(c => c.code === code)?.cities ?? [];
}

/** Normalise une chaîne pour la comparaison (supprime accents, minuscules) */
function normalize(str) {
  return str.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
}

/** Cherche des pays par saisie (retourne max 30 résultats) */
export function searchCountries(query) {
  if (!query?.trim()) return COUNTRIES;
  const q = normalize(query);
  return COUNTRIES.filter(c => normalize(c.name).includes(q)).slice(0, 30);
}

/** Cherche des villes dans un pays (retourne toutes si pas de query) */
export function searchCities(countryCode, query) {
  const cities = getCitiesForCountry(countryCode);
  if (!query?.trim()) return cities;
  const q = normalize(query);
  return cities.filter(city => normalize(city).includes(q));
}
